import React from "react";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { User } from "../../../../data/entities";
import { Avatar, TableRow } from "@mui/material";
import StatusActive from "../../../../shared/components/StatusActive";
import GroupIcon from "../../../../shared/svg/GroupIcon";
import { useNavigate } from "react-router-dom";
import { UserEmail, UserName, UserAvatar, UserInfoWrapper, UserDetailsWrapper } from "./Styled";
import { ROLE } from "../../../../data/enums";

interface UserRowProps {
    item: User;
}

export function stringAvatar(name: string) {
    if (name === "") {
        return "";
    }

    const nameParts = name.trim().split(" ");
    let initials;

    if (nameParts.length === 1) {
        initials = nameParts[0][0];
    } else {
        initials = `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`;
    }

    return {
        children: initials.toUpperCase(),
    };
}

const roleToText = (role: string) => {
    switch (role) {
        case ROLE.MANAGER:
            return "Quản lý";
        case ROLE.FIRST_STORAGE_KEEPER:
            return "Thủ kho 1";
        case ROLE.SECOND_STORAGE_KEEPER:
            return "Thủ kho 2";
        case ROLE.PURCHASING_STAFF:
            return "Nhân viên mua vật tư";
        case ROLE.PRODUCTION_STAFF:
            return "Nhân viên điều phối sản xuất";
        case ROLE.SALE_STAFF:
            return "Nhân viên bán hàng";
        case ROLE.LOGISTIC_STAFF:
            return "Nhân viên hậu cần";
        case ROLE.ACCOUNTANT_MANAGER:
            return "Quản lý kế toán";
        default:
            return role;
    }
};

export const UserRow = ({ item }: UserRowProps) => {
    const navigate = useNavigate();

    const isActive = Boolean(item.is_active);

    const onClickToUserDetail = () => {
        navigate(`/users/${item.id}`);
    };

    const userName = () => {
        const userEmail = item.email;
        const userName =
            item.display_name !== undefined || item.display_name !== ""
                ? item.display_name
                : "";
        return (
            <UserInfoWrapper>
                {item.avatar ? (
                    <UserAvatar src={item.avatar} alt={userName} />
                ) : (
                    <Avatar {...stringAvatar(userName)} sx={{ bgcolor: '#9C27B0', color: 'white', fontSize: '14px', width: 32, height: 32 }} />
                )}
                <UserDetailsWrapper>
                    <UserName> {userName} </UserName>
                    <UserEmail> {userEmail}</UserEmail>
                </UserDetailsWrapper>
            </UserInfoWrapper>
        );
    };

    return (
        <TableRow>
            <StyledTableCell>
                <StyledNavLink to={`/users/${item.id}`}>
                    {item.user_code || ""}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell> {userName()} </StyledTableCell>
            <StyledTableCell> {roleToText(item.role)} </StyledTableCell>
            <StyledTableCell> {item.phone_number}</StyledTableCell>
            <StyledTableCell>
                {" "}
                <StatusActive isActive={isActive} />{" "}
            </StyledTableCell>
            <StyledTableCell>
                <div
                    style={{ cursor: "pointer" }}
                    onClick={onClickToUserDetail}
                >
                    <GroupIcon />
                </div>
            </StyledTableCell>
        </TableRow>
    );
};
